/* eslint-disable max-len */
// #region Actions
const actions = {
  async createExample({_commit, _dispatch, _state}, {_token}) {
    return;
  },
};
// #endregion


// #region Getters
const getters = {
  getLeyendasColores: (state) => state.leyendasColores,
  getColorById: (state) => (_id) => state.leyendasColores.find((color) => color.id == _id)?.codigo,

  /* -------------------- Comun para ccualquier enums ----------------- */
  /* Ejemplo de implementacion:
    store.getters['enums/getEnumsByKey']('EnumTipoDescarga', 'VersionImprimible')
  */
  getTiposPermisoByKey: (state) => (_key) => state.enums?.TiposPermiso[_key],
  getEnumsByKey: (state) => (_tipoKey, _key) => state.enums[_tipoKey][_key],
  getEnumsByValue: (state) => (_tipoKey, _value) => {
    return Object.keys(state.enums[_tipoKey]).find((key) => state.enums[_tipoKey][key] === _value);
  },
  getDescripcionByKey: (state) => (_tipoKey, _key) => state.descriptionEnums[_tipoKey][_key],

  getListTiposEstadoRegistro: (state) => state.enums.TiposEstadoRegistro,

  /* -------------------- Listas apartir de la key del enum y la descripción ----------------- */
  /* Ejemplo de implementacion:
   store.getters['enums/getListObjectEnums']('TiposBusquedaTraslado');
 */
  getListObjectEnums: (state) => (_tipoKey) => {
    const keys = Object.keys(state.descriptionEnums[_tipoKey]);
    return keys.map((element) => {
      return {
        id: state.enums[_tipoKey][element],
        nombre: state.descriptionEnums[_tipoKey][element],
      };
    });
  },
};
// #endregion


// #region Mutations
const mutations = {
  setListEnums(stateTarget, enums) {
    stateTarget.enums = enums;
  },
  setListDescriptionEnums(stateTarget, descriptionEnums) {
    stateTarget.descriptionEnums = descriptionEnums;
  },
  setLeyendasColores(stateTarget, leyendasColores) {
    stateTarget.leyendasColores = leyendasColores;
  },
};
// #endregion


// #regionstateTarget
const stateEnum = () => {
  return {
    enums: {},
    descriptionEnums: {},
    leyendasColores: [],
  };
};
// #endregion


// #region Etc
const namespaced = true;
const modules = [];
// #endregion


export default {
  actions,
  getters,
  modules,
  mutations,
  namespaced,
  stateEnum,
};
